module.exports = __webpack_public_path__ + "static/media/plus-solid.c76c9bdd.svg";